import {
  Box,
  Chip,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow
} from '@mui/material'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import ServerPagination, { IPaginator } from '../../../components/Common/PaginatorServer'
import { LocalesPerfilImp } from '.'
import { useNavigate } from 'react-router'

export interface PropsPI {
  locales: LocalesPerfilImp[]
  loading: boolean
  paginator: IPaginator
  formatDate: (d: string) => string
}

const headers = [
  { key: 'local', label: 'Local' },
  { key: 'whpp', label: 'Whatsapp' },
  { key: 'contrato', label: 'Contrato' },
  { key: 'contratoFechaFin', label: 'Fecha Fin Contrato' }
]

/* eslint-disable react/prop-types */
const TablaLocales: React.FC<PropsPI> = ({ locales, loading, paginator, formatDate }) => {
  const navigate = useNavigate()
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <>
      <TableContainer
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          overflow: 'hidden',
          width: 'auto'
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              {headers.map((h) => (
                <TableCell key={h.key} sx={{ fontWeight: 'bold', fontSize: '18px', color: 'black' }}>
                  {h.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {locales.map((l: LocalesPerfilImp) => (
              <TableRow
                key={l.clienteCodigoLocal}
                onClick={() => navigate(`/admin-local/${l.clienteCodigoLocal}`)}
                sx={{ cursor: 'pointer' }}
              >
                <TableCell>{`${l.clienteNombre} (${l.clienteCodigoLocal})`}</TableCell>
                <TableCell sx={{ px: 2, py: 1.5 }}>
                  <Chip
                    icon={<WhatsAppIcon sx={{ fontSize: 14 }} />}
                    label={l.clienteWhatsapp}
                    size="small"
                    component="a"
                    href={`https://wa.me/${l.clienteWhatsapp.replace(/\D/g, '')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    clickable
                    onClick={(e) => e.stopPropagation()}
                    sx={{
                      fontSize: 12,
                      bgcolor: 'success.50',
                      color: 'success.dark',
                      border: 'none',
                      cursor: 'pointer',
                      textDecoration: 'none',
                      '& .MuiChip-icon': { color: 'success.dark' }
                    }}
                  />
                </TableCell>
                <TableCell>{`${l.productoNombre} (${l.idContrato})`}</TableCell>
                <TableCell>{formatDate(l.contratoFechaFin)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <ServerPagination component={'td'} label="Locales por página" paginator={paginator} />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </>
  )
}

export default TablaLocales
